import { StepComponent } from "../../../../shared/components/ModalFlow/types";
import { FlowUploadDocumentProps } from "./types";
import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import React from "react";

export const Success: StepComponent<FlowUploadDocumentProps> = ({
  state,
  setState,
  onSuccess,
  onNext,
  onBack,
  children
}) => {
  return (
    <WSList gap="2XL">
      <WSCard>
        <WSEmptyState
          type="done"
          title={`Your import was successful!`}
          description={`Congrats! You’re insurance policies were imported successfully in the “My resources” section of your settings.`}
          orientation="horizontal"
        />
      </WSCard>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Continue",
            onAsyncClick: async () => {
              onSuccess();
            }
          }
        ]}
      />
    </WSList>
  );
};
